import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { NgrxStoreIdbTenantResolver } from '@app/core/ngrx/ngrx-store-idb/ngrx-store-idb-tenant-resolver';
import { userTenantFeature } from '@core/user-tenant/user-tenant.reducer';
import { rememberTenantId } from '@core/user-tenant/tenant-context';

/**
 * Bridges the UserTenant feature to the ngrx-store-idb library so the
 * per-tenant IndexedDB store can be created once the tenant is known.
 */
@Injectable()
export class StoreIdbTenantResolverService extends NgrxStoreIdbTenantResolver {
  private store = inject(Store);

  tenantId$(): Observable<string> {
    return this.store.select(userTenantFeature.selectSelectedTenantId).pipe(
      filter((tenantId): tenantId is string => !!tenantId),
      take(1),
    );
  }

  onTenantMismatch(resolvedTenantId: string): void {
    // The IndexedDB store was bootstrapped against another tenant's
    // database (e.g. a different user logged in on this tab). Remember the
    // correct tenant and reload so the whole app bootstraps against it -
    // mirroring what a tenant switch does.
    rememberTenantId(resolvedTenantId);
    window.location.reload();
  }
}
